export default __webpack_public_path__ + "media/images/dashboard_icons/community-advice-bf66010686b1b8b5ae3ee399a9a6a85f.svg";